import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.5)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.25 2C12.25 1.72386 12.0261 1.5 11.75 1.5C11.4739 1.5 11.25 1.72386 11.25 2V3.75H9.5C9.22386 3.75 9 3.97386 9 4.25C9 4.52614 9.22386 4.75 9.5 4.75H11.25V6.5C11.25 6.77614 11.4739 7 11.75 7C12.0261 7 12.25 6.77614 12.25 6.5V4.75H14C14.2761 4.75 14.5 4.52614 14.5 4.25C14.5 3.97386 14.2761 3.75 14 3.75H12.25V2Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.08333 4.75C2.92862 4.75 2.78025 4.81146 2.67085 4.92085C2.56146 5.03025 2.5 5.17862 2.5 5.33333V12.7929L3.81311 11.4798C3.90688 11.386 4.03406 11.3333 4.16667 11.3333H10.6667C10.8214 11.3333 10.9698 11.2719 11.0791 11.1625C11.1885 11.0531 11.25 10.9047 11.25 10.75V9C11.25 8.72386 11.4739 8.5 11.75 8.5C12.0261 8.5 12.25 8.72386 12.25 9V10.75C12.25 11.1699 12.0832 11.5727 11.7863 11.8696C11.4893 12.1665 11.0866 12.3333 10.6667 12.3333H4.37377L2.35355 14.3536C2.21055 14.4966 1.9955 14.5393 1.80866 14.4619C1.62182 14.3845 1.5 14.2022 1.5 14V5.33333C1.5 4.91341 1.66681 4.51068 1.96375 4.21375C2.26068 3.91681 2.66341 3.75 3.08333 3.75H7C7.27614 3.75 7.5 3.97386 7.5 4.25C7.5 4.52614 7.27614 4.75 7 4.75H3.08333Z",
			fill: "currentColor"
		})]
	})]
});
const ForwardRef = forwardRef(SvgNoteAdd);
export default ForwardRef;
